import React from 'react';
import { RESOURCE_CODE } from 'libs/contants';

export interface coachConfig {
  groupDisplayName?: string;
  unitDisplayName?: string;
  id?: string;
}
export interface coachConfig2 {
  groupDisplayName?: string;
  identityDisplayName?: string;
  unitDisplayName?: string;
  practiceDisplayName?: string;
  examDisplayName?: string;
}
export interface LOGO {
  id?: string;
  logo?: string;
  logoUrl?: string;
  name?: string;
}
export interface GLOBAL {
  homePageCode: string;
  logo: LOGO;
  coachConfig: coachConfig;
  coachConfig2: coachConfig2;
  setGlobal(data: any): any;
}

let defaultData: GLOBAL = {
  homePageCode: RESOURCE_CODE.PRACTICE_RECORD,
  logo: {},
  coachConfig: {
    groupDisplayName: '陪练组',
    unitDisplayName: '陪练单元'
  },
  coachConfig2: {
    identityDisplayName: '项目',
    groupDisplayName: '场景',
    unitDisplayName: '情境',
    practiceDisplayName: '练习',
    examDisplayName: '考试'
  },
  setGlobal: () => {}
};
const GlobalContext = React.createContext(defaultData);

export { GlobalContext };
export { defaultData };
